import React, { useCallback } from 'react';
import Card from 'components/inputs/Card';
import { Formik, Form } from 'formik';
import { Row, Col } from 'react-bootstrap';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import * as _ from 'lodash';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { CHANGE_AUTHORIZATION } from 'actions/chargerOcpp';

const ChangeAuthorizationSchema = Yup.object().shape({
  value: Yup.string().required('Authorization key is required!'),
});

const ChangeAuthorizationForm = () => {
  const { chargerId } = useParams();
  const dispatch = useDispatch();

  const initialValues = {
    key: 'AuthorizationKey',
    value: '',
  };

  const changeAuthorization = useCallback((data, resetForm) => {
    dispatch({
      type: CHANGE_AUTHORIZATION,
      payload: { data },
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            toast.success('Authorization change successfully');
            resetForm();
          }
        }
      },
    });
  }, []);

  return (
    <React.Fragment>
      <div className="serverOperation-title-name">CHANGE AUTHORIZATION</div>
      <div className="serverOperation-content-wrapper">
        <Card className="serverOperation-form-main">
          <div className="serverOperation-form__block">
            <Formik
              initialValues={initialValues}
              validationSchema={ChangeAuthorizationSchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                const formData = {
                  id: chargerId,
                  ...values,
                };
                changeAuthorization(formData, resetForm);
                setSubmitting(false);
              }}
            >
              {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="serverOperation-form__inner">
                    <Row>
                      <Col>
                        <TextInput
                          isRequired
                          label="Authorization Key"
                          value={values.value}
                          name="value"
                          onChange={handleChange}
                          error={errors.value && touched.value ? errors.value : null}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="serverOperation-save--btn--block">
                    <Button type="submit" className="serverOperation-save-btn save--btn" disabled={isSubmitting}>
                      Change Authorization
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
export default ChangeAuthorizationForm;
